export const USER_SALARY_CONFIG_PERMISSION_CODES = {
    WEB_PAYROLL_SALARY_CONFIG_LIST: 'WEB_PAYROLL_SALARY_CONFIG_LIST',
    WEB_PAYROLL_SALARY_CONFIG_DETAIL: 'WEB_PAYROLL_SALARY_CONFIG_DETAIL',
    WEB_PAYROLL_SALARY_CONFIG_ADD: 'WEB_PAYROLL_SALARY_CONFIG_ADD',
    WEB_PAYROLL_SALARY_CONFIG_EDIT: 'WEB_PAYROLL_SALARY_CONFIG_EDIT',
    WEB_PAYROLL_SALARY_CONFIG_DELETE: 'WEB_PAYROLL_SALARY_CONFIG_DELETE',
    WEB_PAYROLL_SALARY_CONFIG_IMPORT: 'WEB_PAYROLL_SALARY_CONFIG_IMPORT',
    WEB_PAYROLL_SALARY_CONFIG_EXPORT: 'WEB_PAYROLL_SALARY_CONFIG_EXPORT',
} as const;


